/**
 * نام فایل ویس بر اساس نوع واقعی ضبط.
 * Safari (iOS) وقتی webm را پشتیبانی نکند با audio/mp4 ضبط می‌کند؛ اگر نام فایل .webm باشد
 * سرور/پخش‌کننده ممکن است نوع را از پسوند بخواند و فایل در iOS پخش نشود.
 * برای mp4 صوتی از .m4a استفاده می‌شود تا با ویدیو اشتباه گرفته نشود.
 */
const EXTENSION_BY_MIME = {
  "audio/webm": "webm",
  "audio/mp4": "m4a",
  "audio/x-m4a": "m4a",
  "audio/m4a": "m4a",
  "audio/aac": "aac",
  "audio/ogg": "ogg",
  "audio/mpeg": "mp3",
  "audio/wav": "wav",
  "audio/x-wav": "wav",
};

export function voiceFileExtension(mimeType) {
  const base = String(mimeType || "").split(";")[0].trim().toLowerCase();
  return EXTENSION_BY_MIME[base] || "webm";
}

export function voiceFileName(mimeType, timestamp = Date.now()) {
  return `voice-message-${timestamp}.${voiceFileExtension(mimeType)}`;
}
